import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Input from "../../Atoms/Input/Input";
import styles from "./FormField.module.scss";
import { FaChevronDown, FaTimes,FaCheck, FaEye, FaEyeSlash } from "react-icons/fa";
import {
  symbols,
  numbers,
  smallLetters,
  capitalLetters,
} from "../../../Schemas/validationSchema"; // Adjust the import path accordingly
import _ from "lodash"
import { use } from "react";
export const FormField = ({
  disable=false,
  label,
  placeholder,
  type,
  value,
  onChange,
  error, // Changed from errors to error
  disableNumbers,
  disableSymbols,
  disableSpace,
  isImportant,
  disableAlphebets,
  onBlur = () => {},
  inputClassName,
  className,
  ...props // Spread remaining props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasContent, setHasContent] = useState(!!value);
  const [showPassword, setShowPassword] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    setHasContent(!!event.target.value);
    onBlur(event);
  };

  const handleKeyDown = (event) => {
    if (disableSpace && event.key === " ") {
      event.preventDefault();
    }
    // Disable numbers if the prop is set
    if (disableNumbers && numbers.includes(event.key)) {
      event.preventDefault(); // Prevent entering the number
    }

    // Disable symbols if the prop is set
    if (disableSymbols && symbols.includes(event.key)) {
      event.preventDefault(); // Prevent entering the symbol
    }
    if (
      disableAlphebets &&
      [...smallLetters, ...capitalLetters].includes(event.key)
    ) {
      event.preventDefault(); // Prevent entering the symbol
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(()=>{
    setTimeout(()=>{
      try{
        document.getElementById(props.id).click();
      }catch(_){
        
      }
      
    },1000);
  },[]);

  return (
    <div
      className={`${styles.formField} ${
        isFocused || hasContent || props.focus ? styles.active : ""
      } ${error ? styles.error : ""} ${className}`}
    >
      {label && (
        <label className={styles.floatingLabel}>
          {label}
          {/* <span className="text-danger">{isImportant ? "*" : ""}</span> */}
        </label>
      )}
      <div className={styles.inputWrapper}>
        <Input
          type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
          placeholder={!label ? placeholder : ""}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={onChange}
          value={value}
          disable={disable}
          className={`${styles.inputField} ${isFocused ? styles.focused : ""} ${
            error ? styles.inputError : ""
          } ${inputClassName}`}
          {...props}
        />
        {type === 'password' && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className={styles.passwordToggle}
            disabled={disable}
            style={{ right: '10px' }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        )}
      </div>
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disableNumbers: PropTypes.bool,
  disableSymbols: PropTypes.bool,
  disableSpace: PropTypes.bool,
  isImportant: PropTypes.bool,
  disableAlphebets: PropTypes.bool,
};

export const FormFieldMail = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  isImportant,
  disableSpace,
  disableSymbols,
  onBlur = () => {},
  inputClassName,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasContent, setHasContent] = useState(!!value);

  const handleFocus = () => setIsFocused(true);

  const handleBlur = (event) => {
    setIsFocused(false);
    setHasContent(!!event.target.value);
    onBlur(event);
  };

  const handleKeyDown = (event) => {
    if (disableSpace && event.key === " ") {
      event.preventDefault();
    }
    if (disableSymbols && symbols.includes(event.key)) {
      event.preventDefault(); // Prevent entering specific symbols
    }
  };

  return (
    <div
      className={`${styles.formField} ${
        isFocused || hasContent || props.focus ? styles.active : ""
      } ${error ? styles.error : ""}`}
    >
      {label && (
        <label className={styles.floatingLabel}>
          {label} {isImportant && <span className="text-danger">*</span>}
        </label>
      )}
      <Input
        type="email"
        placeholder={!label ? placeholder : ""}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={onChange}
        value={value}
        className={`${styles.inputField} ${isFocused ? styles.focused : ""} ${
          error ? styles.inputError : ""
        } ${inputClassName}`}
        {...props}
      />
    </div>
  );
};

FormFieldMail.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  isImportant: PropTypes.bool,
  disableSpace: PropTypes.bool,
  disableSymbols: PropTypes.bool,
};
export const FormDropdown = ({
  label,
  options = [],
  onChange = () => {},
  error = false,
  value,
  className,
  disabled = false, // Add disabled prop
  enable_search=true,
  api_search=null
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected_item, setSelected_item] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [filteredOptions, setFilteredOptions] = useState(options);

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    if (disabled) return; // Prevent interaction if disabled
    setIsOpen((prev) => !prev);
    if (!isOpen) {
      setSearchQuery(""); // Clear search query when dropdown is opened
    }
  };

  // Handle selection from dropdown
  const handleSelect = (event, option) => {
    if (disabled) return;
    event.stopPropagation();
    console.log("Selecting option:", option); // Add this for debugging
    onChange(option); // Update the selected value
    setSelected_item(option);
    setIsOpen(false);
    setSearchQuery(""); // Clear search after selection
  };

  // Clear selected option
  const clearSelection = (event) => {
    if (disabled) return; // Prevent clearing selection if disabled
    event.stopPropagation();
    onChange(""); // Clear selected value
    setSearchQuery(""); // Clear search query
    setIsOpen(false);
    setSelected_item(null);
  };

  // Update the selected item based on the current value
  useEffect(() => {
    setSelected_item(options.find((item) => item.id === value || item.label === value));
  }, [value, options]);

  // Handle changes in the search input
  const [debounce,setDebounce] = useState(null)
  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    if (debounce) {
      clearTimeout(debounce);
    }

    const newDebounce = setTimeout(() => {
     
      if (api_search != null) {
        api_search(query); 
      }
      
    }, 500);

   
    setDebounce(newDebounce);
  };

  // Filter options based on search query
  useEffect(() => {
    if(api_search==null){
    if (searchQuery) {
      setFilteredOptions(
        options.filter((option) =>
          option.label.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    } else {
      setFilteredOptions(options); // Show all options if no search query
    }
  }
  }, [searchQuery, options]);

  // Prevent closing dropdown when clicking inside the search input field
  const preventBlur = (e) => {
    e.stopPropagation(); // Stop the event from propagating to the container
  };

  return (
    <div
      className={`${styles.dropdownContainer} ${isOpen ? styles.active : ""} ${error ? styles.errorBorder : ""} ${className} ${disabled ? styles.disabled : ""}`}
      onClick={toggleDropdown}
      onMouseLeave={() => setIsOpen(false)}
    >
      {(!value || !selected_item) && (
        <label className={styles.floatingLabel}>
          {label=="SENP"?"Self Employed Non Professional":label=="SEP"?"Self Employed Professional":label}
        </label>
      )}
      
      <div className={styles.selectedOption}>
        {selected_item?.label=="SENP"?"Self Employed Non Professional":selected_item?.label=="SEP"?"Self Employed Professional":selected_item?.label || selected_item?.name}
      </div>

      {/* Icons */}
      <div className={styles.iconContainer}>
        {selected_item && (
          <span className={styles.clearIcon} onClick={clearSelection}>
            <FaTimes />
          </span>
        )}
        <span className={`${styles.dropdownIcon} ${isOpen ? styles.rotated : ""} fs-6`}>
          <FaChevronDown />
        </span>
      </div>

      {/* Dropdown with search */}
      {isOpen && (
        <div className={styles.options}>
          { /* Search input */
          enable_search&&<input
            type="text"
            className={styles.searchInput}
            value={searchQuery}
            onChange={handleSearchChange}
            onClick={preventBlur}
            placeholder="Search..."
          />
      }
          {/* Options */}
          {filteredOptions.length === 0 ? (
            <div className={styles.noOptions}>No options found</div>
          ) : (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className={`${styles.option} ${
                  (value === option.id || value === option.label) ? styles.selected : ""
                }`}
                onMouseDown={(e) => handleSelect(e, option)}
              >
                <span>
                  {option?.label=="SENP"?"Self Employed Non Professional":option?.label=="SEP"?"Self Employed Professional":option?.label}
                </span>
                {(value === option.id || value === option.label) && (
                  <span className={styles.tickIcon}>
                    <FaCheck />
                  </span>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};





export const FormTextArea = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  disableNumbers,
  disableSymbols,
  disableSpace,
  isImportant,
  disableAlphebets,
  onBlur = () => {},
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasContent, setHasContent] = useState(!!value);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    setHasContent(!!event.target.value);
    onBlur(event);
  };

  const handleKeyDown = (event) => {
    if (disableSpace && event.key === " ") {
      event.preventDefault();
    }
    // Disable numbers if the prop is set
    if (disableNumbers && numbers.includes(event.key)) {
      event.preventDefault(); // Prevent entering the number
    }

    // Disable symbols if the prop is set
    if (disableSymbols && symbols.includes(event.key)) {
      event.preventDefault(); // Prevent entering the symbol
    }
    if (
      disableAlphebets &&
      [...smallLetters, ...capitalLetters].includes(event.key)
    ) {
      event.preventDefault(); // Prevent entering the symbol
    }
  };

  return (
    <div className={`${styles.formField} ${isFocused || hasContent ? styles.active : ""} ${error ? styles.error : ""}`}>
      {label && (
        <label className={styles.floatingLabel}>
          {label}
        </label>
      )}
      <textarea
        placeholder={!label ? placeholder : ""}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={onChange}
        value={value}
        className={`${styles.textAreaField} ${isFocused ? styles.focused : ""} ${error ? styles.inputError : ""}`}
        {...props}
      />
    </div>
  );
};


export const CalendarInput = ({
  label,
  value,
  onChange,
  error,
  isImportant,
  onBlur = () => {},
  inputClassName,
  className,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasContent, setHasContent] = useState(!!value);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    setHasContent(!!event.target.value);
    onBlur(event);
  };

  const handleInputChange = (event) => {
    let inputValue = event.target.value.replace(/\D/g, ""); // Remove any non-numeric characters

    // Apply DD/MM/YYYY formatting as the user types
    if (inputValue.length >= 2 && inputValue.length < 4) {
      inputValue = inputValue.slice(0, 2) + "/" + inputValue.slice(2);
    } else if (inputValue.length >= 4) {
      inputValue = inputValue.slice(0, 2) + "/" + inputValue.slice(2, 4) + "/" + inputValue.slice(4, 8);
    }

    // if (inputValue.length >= 4) {
    //      inputValue = inputValue.slice(0, 4) + "/" + inputValue.slice(4, 6) + "/" + inputValue.slice(6, 8);
    // }else if (inputValue.length >= 4 && inputValue.length <=4){
    //   inputValue = inputValue.slice(0, 4)
    // }

    // Limit input to 10 characters (DD/MM/YYYY)
    if (inputValue.length <= 10) {
      onChange({ target: { value: inputValue } });
    }
  };

  return (
    <div
      className={`${styles.formField} ${
        isFocused || hasContent ? styles.active : ""
      } ${error ? styles.error : ""} ${className}`}
    >
      {label && (
        <label className={styles.floatingLabel}>
          {label}
          {/* {isImportant && <span className="text-danger">*</span>} */}
        </label>
      )}
      <input
        type="text"
        placeholder={isFocused ? "DD/MM/YYYY" : ""}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleInputChange}
        value={value}
        className={`${styles.inputField} ${isFocused ? styles.focused : ""} ${
          error ? styles.inputError : ""
        } ${inputClassName}`}
        maxLength="10"
        {...props}
      />
    </div>
  );
};

CalendarInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  isImportant: PropTypes.bool,
};





